export const GPS_POLICY_QUOTE_REQUEST = "gps_quote_request";
export const CHANGE_COC_REQUEST = "change_coc_request";
export const INKA_INVITE = "income_insurance_invite";